var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trail-episode-slide py-4 py-md-0"},[_c('router-link',{staticClass:"text-light text-decoration-none",attrs:{"to":{
      name: 'trail-episode',
      params: {
        trail: _vm.trail,
        id: _vm.resource.id
      }
    }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img}}),_c('h6',[_vm._v(_vm._s(_vm.resource.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }